export default __webpack_public_path__ + "static/media/USDC-DAI.67dc07e1.png";